import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile, NzUploadChangeParam, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { Observable, Observer } from 'rxjs';
import { SharedTabDataService } from '../shared-tab-data-service.component';
import { EcatService } from 'src/app/services/ecat.service';
import { LoginService } from 'src/app/services/login.service';
import { Subscription } from 'rxjs';
import { encryptParam } from 'src/app/utils/encrypt';
import { NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/services/sharedDataService.service';

interface VehicleData {
  id: number;
  carId: string;
  carBrandName: string;
  modelClass: string;
  carName: string;
  displacement: string;
  modelYear: string;
  carModelName: string;
  engineCode: string;
  checked: boolean;
}

@Component({
  selector: 'app-vin-search',
  templateUrl: './vin-search.component.html',
  styleUrls: ['./vin-search.component.less']
})
export class VinSearchComponent implements OnInit {
  vinCode: string = '';
  privacyAgreed: boolean = false;
  vinError: boolean = false;
  isPrivacyVisible = false;
  isUploadVisible = false;
  loading = false;
  avatarUrl?: string;
  confirmModal?: NzModalRef;
  pageIndex = 1;
  tableLoading = false;
  allChecked = false;
  indeterminate = false;
  checkedList: VehicleData[] = [];
  searchValue = '';
  originalData: VehicleData[] = [];
  vehData: VehicleData[] = [];
  imageBase64: string | null = null;
  pageSize = 10;
  deselectedVeh: any[] = [];
  isSearchByVinCode = false;
  selectedLevelIds = '';
  isCarTableLoading = false;
  isDealerPortal: boolean = false;

  checkedMap: { [key: string]: boolean } = {};
  globalSelectAll = false;
  globalUnselected: Set<string> = new Set<string>();
  selectedVehToPass: any[] = [];

  // Sorting functions
  sortCarBrandNameFn = (a: VehicleData, b: VehicleData) => a.carBrandName.localeCompare(b.carBrandName);
  sortModelClassFn = (a: VehicleData, b: VehicleData) => a.modelClass.localeCompare(b.modelClass);
  sortCarNameFn = (a: VehicleData, b: VehicleData) => a.carName.localeCompare(b.carName);
  sortDisplacementFn = (a: VehicleData, b: VehicleData) => a.displacement.localeCompare(b.displacement);
  sortYearFn = (a: VehicleData, b: VehicleData) => a.modelYear.localeCompare(b.modelYear);
  sortCarModelNameFn = (a: VehicleData, b: VehicleData) => a.carModelName.localeCompare(b.carModelName);
  sortEngineCodeFn = (a: VehicleData, b: VehicleData) => a.engineCode.localeCompare(b.engineCode);

  hotBrands = [
    { id: 1, brand: '大众', image: 'assets/official-website/das.png' },
    { id: 2, brand: '宝马', image: 'assets/official-website/bmw.png' },
    { id: 3, brand: '奔驰', image: 'assets/official-website/benz.png' },
    { id: 4, brand: '奥迪', image: 'assets/official-website/audi.png' },
    { id: 5, brand: '斯柯达', image: 'assets/official-website/sikeda.png' },
    { id: 6, brand: '本田', image: 'assets/official-website/honda.png' },
    { id: 7, brand: '丰田', image: 'assets/official-website/toyota.png' },
    { id: 8, brand: '日产', image: 'assets/official-website/nissan.png' },
    { id: 9, brand: '马自达', image: 'assets/official-website/mazda.png' },
    { id: 10, brand: '别克', image: 'assets/official-website/buick.png' },
    { id: 11, brand: '雪佛兰', image: 'assets/official-website/cheverlet.png' },
    { id: 12, brand: '凯迪拉克', image: 'assets/official-website/kaidilake.png' },
    { id: 13, brand: '福特', image: 'assets/official-website/ford.png' },
    { id: 14, brand: '沃尔沃', image: 'assets/official-website/volvo.png' },
    { id: 15, brand: '现代', image: 'assets/official-website/xiandai.png' },
    { id: 16, brand: '起亚', image: 'assets/official-website/kia.png' },
    { id: 17, brand: '标致', image: 'assets/official-website/biaozhi.png' },
    { id: 18, brand: '雪铁龙', image: 'assets/official-website/xuetielong.png' },
    { id: 19, brand: '荣威', image: 'assets/official-website/rongwei.png' },
    { id: 20, brand: '比亚迪', image: 'assets/official-website/byd.png' },
  ];

  // allBrands: string[] = ["大众", "宝马", "奔驰", "奥迪", "斯柯达", "本田", "丰田", "日产", "马自达", "别克", "雪佛兰", "凯迪拉克", "福特", "沃尔沃", "现代", "起亚", "标致", "雪铁龙", "荣威", "比亚迪"];
  allBrands: any[] = [];
  allFilteredSeries: any[] = [];
  allFilteredModels: any[] = [];
  allFilteredDisplacements: any[] = [];
  allFilteredYears: any[] = [];
  allFilteredCars: any[] = [];
  selectedBrand: any = {};
  selectedSeries: any = {};
  selectedModel: any = {};
  selectedDisplacement: any[] = [];
  selectedYear: any[] = [];
  selectedBrandId: number | null = null;

  allSeries: { [brand: string]: string[] } = {
    '大众': ['高尔夫', '帕萨特', '迈腾', '宝来', '速腾'],
    '宝马': ['3系', '5系', '7系', 'X1', 'X3'],
    // 其他品牌的系列...
  };

  allModels: { [series: string]: string[] } = {
    '高尔夫': ['1.4T 舒适型', '1.4T 豪华型', '1.6L 舒适型'],
    '帕萨特': ['1.8T 尊荣版', '2.0T 御尊版', '2.0T 至尊版'],
    // 其他系列的型号...
  };

  displacements: string[] = ['1.0', '1.2', '1.4', '1.5', '1.6', '1.8', '2.0', '2.4', '2.5', '3.0'];

  years: string[] = [];

  pageInfo: any = {}

  constructor(private messageService: NzMessageService, private message: NzMessageService,
    private sharedData: SharedTabDataService, private ecatService: EcatService, private modal: NzModalService,
    private loginService: LoginService, private sharedDataService: SharedDataService) {
    this.sharedDataService.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }
  @Output() dataEvent = new EventEmitter<string>();
  ngOnInit(): void {
    this.getBrand();
    this.loadData();
    // 生成年款选项，从当前年款往前推20年
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 20; i++) {
      this.years.unshift((currentYear - i).toString());
    }
  }

  loadData(): void {
    this.tableLoading = true;
    // Simulate API call
    setTimeout(() => {
      this.originalData = this.generateData();
      this.vehData = [...this.originalData];
      this.tableLoading = false;
    }, 500);
  }

  generateData(): VehicleData[] {
    const vehData: VehicleData[] = [
    ];
    return vehData;
  }

  onPageIndexChange(pageIndex: number): void {
    this.pageIndex = pageIndex;
    this.handleSearchCars();
  }

  // Selection logic
  onAllChecked(checked: boolean): void {
    this.globalSelectAll = checked;
    this.vehData.forEach(item => {
      this.checkedMap[item.carId] = checked;
      if (this.globalSelectAll) {
        if (!checked) {
          this.globalUnselected.add(item.carId);
        } else {
          this.globalUnselected.delete(item.carId);
        }
      }
    });
    if (!checked) {
      this.checkedMap = {};
      this.selectedVehToPass = [];
      this.globalUnselected = new Set<string>();
    }
    if (this.isSearchByVinCode) {
      if (checked) {
        this.vehData.forEach(item => {
          if (!this.selectedVehToPass.includes(item)) {
            this.selectedVehToPass.push(item)
          }
        })
      } else {
        this.selectedVehToPass = []
      }
    }
    this.refreshCheckedStatus();
  }

  onItemChecked(item: VehicleData, checked: boolean): void {
    this.checkedMap[item.carId] = checked;
    if (this.globalSelectAll) {
      if (!checked) {
        this.globalUnselected.add(item.carId);
      } else {
        this.globalUnselected.delete(item.carId);
      }
    }
    if (checked) {
      this.selectedVehToPass.push(item)
    } else {
      this.selectedVehToPass = this.selectedVehToPass.filter((veh) => veh.carId !== item.carId);
    }
    this.refreshCheckedStatus();
  }

  resetCheckStatus() {
    this.checkedMap = {};
    this.globalSelectAll = false;
    this.globalUnselected = new Set<string>();
    this.selectedVehToPass = [];
  }

  refreshCheckedStatus(): void {

    const unSelectedLength = this.globalUnselected.size;
    const selectedIds = Object.keys(this.checkedMap)
      .filter(key => this.checkedMap[+key])
      .map(id => +id);

    if (this.globalSelectAll && unSelectedLength > 0) {
      this.indeterminate = true;
    } else if (!this.globalSelectAll && selectedIds.length > 0) {
      this.indeterminate = true;
    } else {
      this.indeterminate = false;
    }

    if (this.globalSelectAll && unSelectedLength === 0) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }

    if (this.isSearchByVinCode && selectedIds.length === 0) {
      this.indeterminate = false;
      this.allChecked = false;
      this.globalSelectAll = false;
    }
  }

  search(): void {
    if (!this.searchValue) {
      this.vehData = [...this.originalData];
      return;
    }
    this.vehData = this.originalData.filter(item =>
      Object.values(item).some(val =>
        val.toString().toLowerCase().includes(this.searchValue.toLowerCase())
      )
    );
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.handleSearchCars();
  }

  getBrand() {
    this.ecatService.getBrand({
      languageType: 'zh-cn'
    }).subscribe(result => {
      const { resultCode, resultData } = result;
      this.allBrands = resultData.carBrand;
    });
  }

  checkVinLength(): void {
    this.vinError = this.vinCode.length > 0 && this.vinCode.length !== 17;
  }

  selectBrand(car: any): void {
    this.selectedSeries = {};
    this.selectedModel = {};
    this.selectedDisplacement = [];
    this.selectedYear = [];
    this.allFilteredSeries = [];
    this.allFilteredModels = [];
    this.allFilteredDisplacements = [];
    this.allFilteredYears = [];
    const brand: any = this.allBrands.filter((item: any) => item.brandName === car.brand);
    this.selectedBrand = brand[0];
    this.getSeriesList(brand[0].brandId);
    this.selectedBrandId = car.id;
  }

  handleResetFilter() {
    this.selectedBrand = {};
    this.selectedSeries = {};
    this.selectedModel = {};
    this.selectedDisplacement = [];
    this.selectedYear = [];
    this.allFilteredSeries = [];
    this.allFilteredModels = [];
    this.allFilteredDisplacements = [];
    this.allFilteredYears = [];
    this.selectedBrandId = null;
    this.allChecked = false;
    this.vehData = [];
    this.indeterminate = false;
    this.checkedMap = {};
    this.selectedVehToPass = [];
  }

  handleResetVinCodeSearch() {
    this.isSearchByVinCode = false;
    this.vinCode = '';
    this.privacyAgreed = false;
    this.selectedLevelIds = '';
  }

  onHandlePrivacy() {
    this.isPrivacyVisible = true;
  }

  handleOk(): void {
    console.log('Button ok clicked!');
    this.isPrivacyVisible = false;
  }

  handleCancel(): void {
    console.log('Button cancel clicked!');
    this.isPrivacyVisible = false;
  }

  onUploadVinPhoto() {
    this.isUploadVisible = true;
  }

  onHandleSearch(): void {
    this.resetCheckStatus();
    if (this.vinCode.length === 0) {
      this.message.create('warning', '请输入VIN码');
    } else if (this.vinCode.length !== 17) {
      this.message.create('warning', 'VIN码必须为17位字符');
    } else if (!this.privacyAgreed) {
      this.message.create('warning', '请阅读并同意关于VIN码的隐私条款');
    } else {
      this.handleResetFilter();
      this.isSearchByVinCode = true;
      this.ecatService.queryVinCode({ vinCode: this.vinCode, languageType: 'zh-cn' }).subscribe(result => {
        const { resultCode, resultData, resultMsg } = result;
        if (resultCode !== '0') {
          this.message.create('error', resultMsg);
        } else {
          this.vehData = resultData.carInfoList;
          this.selectedLevelIds = resultData.levelIds;
          this.vehData.forEach(item => {
            if (this.globalSelectAll) {
              this.checkedMap[item.carId] = !this.globalUnselected.has(item.carId);
            } else {
              this.checkedMap[item.carId] = this.checkedMap[item.carId] || false;
            }
          });
          this.refreshCheckedStatus();
          this.pageInfo = resultData.pageInfo;
        }
      });
      // this.privacyAgreed = false;
      if (environment.production) {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        const customer = JSON.parse(localStorage.getItem('customer') || '{}');
        (window as any).dataLayer.push({
          event: 'dp_eact_search_click',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: 'VIN',
          event_name: '',
          portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
          event_content: this.vinCode,
        });
      }
    }
  }

  handleUploadOk(): void {
    console.log('Button ok clicked!');
    this.isUploadVisible = false;
  }

  handleUploadCancel(): void {
    console.log('Button cancel clicked!');
    this.isUploadVisible = false;
  }

  handleChange = (item: NzUploadXHRArgs): Subscription => {
    const file = item.postFile as File;
    const sub = new Subscription(); // 创建一个空的 Subscription

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;
      this.ecatService.getVinCode({ imageBase64Data: base64, languageType: 'zh-cn' }).subscribe(result => {
        const { resultCode, resultData } = result;
        if (resultCode === '02') {
          this.message.create('error', result.resultMsg);
        }
        this.isUploadVisible = false;
        this.vinCode = resultData.vinCode;
        this.checkVinLength();
        console.log('resultData', resultData)
      });
    };
    reader.onerror = (error) => {
    };
    reader.readAsDataURL(file);
    return sub;
  };

  handleSearchParts() {
    const selectedIds = Object.keys(this.checkedMap)
      .filter(key => this.checkedMap[+key])
      .map(id => +id);
    const unSelectedIds = Array.from(this.globalUnselected);

    if (this.globalSelectAll && this.isSearchByVinCode === false) {
      console.log('全选状态，未选中的id:', unSelectedIds);
    } else {
      console.log('非全选状态，选中的id:', selectedIds);
      console.log('非全选状态，选中的item:', this.selectedVehToPass);
    }

    if ((!this.globalSelectAll && selectedIds.length === 0) || (this.isSearchByVinCode && selectedIds.length === 0)) {
      this.message.create('warning', '请至少选择一款车型');
    } else {
      const selectedSeries = this.selectedSeries;
      const queryParams = {
        brandId: this.selectedBrand.brandId,
        manufacturer: this.isEmptyObject(selectedSeries) ? '' : selectedSeries.manufacturer,
        modelClass: this.isEmptyObject(selectedSeries) ? '' : selectedSeries.modelClass,
        modelName: !this.isEmptyObject(this.selectedModel) ? this.selectedModel.modelName : '',
        displacement: this.selectedDisplacement.toString(),
        modelYear: this.selectedYear.toString(),
        languageType: 'zh-cn'
      }
      if (this.globalSelectAll && this.isSearchByVinCode === false) {
        if (this.pageInfo.totalCounts > 100) {
          this.showConfirm(queryParams);
        } else {
          const dataToPass = {
            deselectedVeh: unSelectedIds,
            selectedVeh: this.selectedVehToPass,
            allChecked: true,
            selectedLevelIds: '',
            selectedVinCode: '',
            queryParams: queryParams
          }
          this.sharedData.updateTabData({
            key: 'selectedVeh',
            otherData: dataToPass
          });
          this.dataEvent.emit('true');
        }
      } else {
        const dataToPass = {
          deselectedVeh: unSelectedIds,
          selectedVeh: this.selectedVehToPass,
          allChecked: false,
          selectedLevelIds: this.selectedLevelIds,
          selectedVinCode: this.vinCode,
          queryParams: queryParams
        }
        this.sharedData.updateTabData({
          key: 'selectedVeh',
          otherData: dataToPass
        });
        this.dataEvent.emit('true');
      }
    }
  }

  showConfirm(queryParams: any): void {
    this.confirmModal = this.modal.confirm({
      nzTitle: '提示',
      nzContent: '当前选中条数超过100条请求超时，是否继续？',
      nzOnOk: () => {
        const unSelectedIds = Array.from(this.globalUnselected);
        const dataToPass = {
          deselectedVeh: unSelectedIds,
          selectedVeh: this.selectedVehToPass,
          allChecked: true,
          selectedLevelIds: '',
          selectedVinCode: '',
          queryParams: queryParams
        }
        this.sharedData.updateTabData({
          key: 'selectedVeh',
          otherData: dataToPass
        });
        this.dataEvent.emit('true');
      }
    })
  }

  onSelectBrandChange(brandSelected: any) {
    this.selectedSeries = {};
    this.selectedModel = {};
    this.selectedDisplacement = [];
    this.selectedYear = [];
    this.allFilteredSeries = [];
    this.allFilteredModels = [];
    this.allFilteredDisplacements = [];
    this.allFilteredYears = [];
    if (brandSelected === null) {
      return;
    }
    const selectedBrand = this.allBrands.filter((item: any) => item.brandId === brandSelected.brandId);
    const brand: any = this.hotBrands.filter((item: any) => item.brand === selectedBrand[0].brandName);
    if (brand.length > 0) {
      this.selectedBrandId = brand[0].id;
    } else {
      this.selectedBrandId = null;
    }
    this.getSeriesList(brandSelected.brandId);
  }

  getSeriesList(item: any) {
    this.ecatService.seriesList({ brandId: item, languageType: 'zh-cn' }).subscribe(result => {
      const { resultCode, resultData } = result;
      this.allFilteredSeries = resultData.carSeriesList;
    });
  }

  onSelectSeriesChange(item: any) {
    this.selectedModel = {};
    this.selectedDisplacement = [];
    this.selectedYear = [];
    this.allFilteredModels = [];
    this.allFilteredDisplacements = [];
    this.allFilteredYears = [];
    if (item === null) {
      return;
    }
    const encodedManufacture = encodeURIComponent(item.manufacturer);
    const data = {
      brandId: this.selectedBrand.brandId,
      modelId: '',
      modelClass: item.modelClass + ',' + encodedManufacture,
      displacement: '',
      modelYear: '',
      languageType: 'zh-cn',
      sop: '',
      eop: ''
    }
    console.log('data', data)
    this.ecatService.modelYearDisplacementList(data).subscribe(result => {
      const { resultCode, resultData } = result;
      this.allFilteredModels = resultData.carModelList;
      this.allFilteredDisplacements = resultData.displacementList;
      this.allFilteredYears = resultData.modelYearList;
      console.log('resultData', resultData)
    });
  }

  onSelectModelChange(item: any) {
    this.selectedDisplacement = [];
    this.selectedYear = [];
    this.allFilteredDisplacements = [];
    this.allFilteredYears = [];
    if (item === null) {
      return;
    }
    this.ecatService.displacementList({ brandId: this.selectedBrand.brandId, modelId: item.modelId, languageType: 'zh-cn' }).subscribe(result => {
      const { resultCode, resultData } = result;
      this.allFilteredDisplacements = resultData.displacementList;
    });
  }

  onSelectDisplacementChange(item: any) {
    this.selectedYear = [];
    this.allFilteredYears = [];
    if (item === null) {
      return;
    }
    const selectedSeries = this.selectedSeries;
    const encodedManufacture = encodeURIComponent(selectedSeries.manufacturer);
    const modelClass = selectedSeries.modelClass + ',' + encodedManufacture
    const params = {
      brandId: this.selectedBrand.brandId, modelId: !this.isEmptyObject(this.selectedModel) ? this.selectedModel.modelId : '', modelClass: modelClass,
      displacement: item, modelYear: '', languageType: 'zh-cn'
    }
    this.ecatService.modelyearList(params).subscribe(result => {
      const { resultCode, resultData } = result;
      this.allFilteredYears = resultData.modelYearList;
    });
  }

  isEmptyObject(obj: any) {
    if (obj === null) {
      return true;
    }
    return Object.keys(obj).length === 0;
  }

  handleClickSearchCars() {
    this.resetCheckStatus();
    this.handleSearchCars();
  }

  handleSearchCars() {
    if (!this.isEmptyObject(this.selectedSeries) && !this.isEmptyObject(this.selectedBrand)) {
      this.isCarTableLoading = true;
      this.handleResetVinCodeSearch();
      const selectedSeries = this.selectedSeries;
      const encodedManufacture = encodeURIComponent(selectedSeries.manufacturer);
      const modelClass = selectedSeries.modelClass;
      const params = {
        page: this.pageIndex,
        pageSize: this.pageSize,
        brandId: encryptParam(this.selectedBrand.brandId),
        manufacturer: encryptParam(encodedManufacture),
        modelClass: encryptParam(modelClass),
        modelId: encryptParam(!this.isEmptyObject(this.selectedModel) ? this.selectedModel.modelId : ''),
        displacement: encryptParam(this.selectedDisplacement.toString()),
        modelYear: encryptParam(this.selectedYear.toString()),
        languageType: encryptParam('zh-cn')
      }
      this.ecatService.carQuery(params).subscribe(result => {
        this.isCarTableLoading = false;
        const { resultCode, resultData } = result;
        this.vehData = resultData.carInfoList;
        this.vehData.forEach(item => {
          if (this.globalSelectAll) {
            this.checkedMap[item.carId] = !this.globalUnselected.has(item.carId);
          } else {
            this.checkedMap[item.carId] = this.checkedMap[item.carId] || false;
          }
        });
        this.refreshCheckedStatus();
        this.pageInfo = resultData.pageInfo;
        if (this.allChecked === true) {
          this.vehData.forEach(item => (item.checked = true));
        }
      });
      if (environment.production) {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        const customer = JSON.parse(localStorage.getItem('customer') || '{}');
        (window as any).dataLayer.push({
          event: 'dp_eact_search_click',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: 'vehicle',
          event_name: '',
          portal_name: 'PC ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
          event_content: selectedSeries.manufacturer + " " + modelClass + " " + this.selectedYear.toString() + " " + this.selectedDisplacement.toString(),
        });
      }
    } else {
      this.message.create('warning', '请正确选择品牌, 车系');
    }
  }

  brandFilterOption = (input: string, option: any): boolean => {
    const keyword = input.toLowerCase();
    return (
      // 中文或英文名字包含输入
      option.nzLabel.toLowerCase().includes(keyword) ||
      // 拼音首字母包含输入
      option.nzValue.brandNamePY.toLowerCase().includes(keyword)
    );
  };

  seriesFilterOption = (input: string, option: any): boolean => {
    const keyword = input.toLowerCase();
    return (
      // 中文或英文名字包含输入
      option.nzLabel.toLowerCase().includes(keyword) ||
      // 拼音首字母包含输入
      option.nzValue.modelClassPY.toLowerCase().includes(keyword)
    );
  };

  modelFilterOption = (input: string, option: any): boolean => {
    const keyword = input.toLowerCase();
    return (
      // 中文或英文名字包含输入
      option.nzLabel.toLowerCase().includes(keyword) ||
      // 拼音首字母包含输入
      option.nzValue.modelNamePY.toLowerCase().includes(keyword)
    );
  };
}
